import Vue from 'vue';

Vue.component('accordion-wrapper', {
    props: {
        accordionBlock: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            activeIndex: 0,
            activeImage: null,
        };
    },

    mounted() {
        this.activeImage = this.accordionBlock[this.activeIndex].image;
    },

    watch: {
        activeIndex(newValue) {
            this.activeImage = this.accordionBlock[newValue].image;
        },
    },

    methods: {
        toggleItem(index) {
            this.activeIndex = this.activeIndex === index ? null : index;
        },
        isAccordionItemActiveBoolean(index) {
            return this.activeIndex === index;
        },
        isButtonActive(index) {
            return this.activeIndex === index
                ? 'services-accordion__accordion-button--active'
                : '';
        },
        isAccordionItemActive(index) {
            return this.activeIndex === index
                ? 'services-accordion__accordion-content--active'
                : '';
        },
        parseImage(image) {
            return JSON.parse(image);
        },
    },
});
